import { render, staticRenderFns } from "./SearchPages.vue?vue&type=template&id=4cf2f896&scoped=true&"
import script from "./SearchPages.vue?vue&type=script&lang=js&"
export * from "./SearchPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2f896",
  null
  
)

export default component.exports